import type { StackProps } from '@mantine/core';
import { Stack, createStyles } from '@mantine/core';
import { pageFadeInAnimation } from '@repo/theme/primitives';
import { useCallback } from 'react';
import { uploadFileTransferItemsAsAttachments } from '../../../components/AIAssistant/utils';
import type { AiChatStore } from '../store';

const useStyles = createStyles((theme) => ({
	wrapper: {
		width: '100%',
		height: '100%',
		paddingBottom: theme.spacing.xl,
		gap: 0,
		display: 'flex',
		flexDirection: 'column',
		overflow: 'hidden',
		...pageFadeInAnimation,
	},
}));

export function AiChatBody({
	children,
	className,
	store,
	...props
}: { children: React.ReactNode; store?: AiChatStore } & StackProps) {
	const { classes, cx } = useStyles();

	const onDrop = useCallback(
		(e: React.DragEvent<HTMLDivElement>) => {
			e.preventDefault();

			if (!store) return;

			const items = [...e.dataTransfer.items];
			uploadFileTransferItemsAsAttachments(items, store);
		},
		[store]
	);

	return (
		<Stack
			onDrop={onDrop}
			className={cx(classes.wrapper, className)}
			{...props}
		>
			{children}
		</Stack>
	);
}
